import React from "react";
import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

type Avatar39Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar39 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar39Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar39" clipPath="url(#clip0_2286_5431)">
        <Path
          id="background"
          d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
          fill={c.background}
        />
        <Path
          id="skin"
          d="M221.844 141.576c-6.219-2.118-10.663-.868-14.159 2.445a161.011 161.011 0 0 0-.335-7.932c-3.456-51.169-6.522-83.526-85.119-83.526-43.531 0-41.564 45.936-41.564 97.224 0 16.931-1.728 17.234.454 31.537 9.421 34.476 17.218 58.543 40.537 61.96l9.588 44.614 77.569-48.795-5.32-50.03s.024.008.032.016c7.805 2.66 18.238-5.814 23.303-18.93 5.065-13.117 2.835-25.907-4.97-28.567l-.016-.016Z"
          fill={c.skin}
        />
        <Path
          id="Vector"
          d="M173.893 136.344c.311.398-.055.971-.541.836-3.066-.836-10.465-2.469-21.145-2.389-7.956.056-17.855 2.524-21.383 2.986-5.559.717-5.606-9.047-5.606-9.047-.271-1.513 14.422-6.801 27.897-6.745 11.269.048 13.826 5.519 20.778 14.367v-.008Z"
          fill="#000"
        />
        <Path
          id="Vector_2"
          d="M224.887 204.435v-.024h.016c0 .008 0 .016-.008.024h-.008Z"
          fill="#fff"
          stroke="#000"
          strokeMiterlimit={10}
        />
        <Path
          id="Vector_3"
          d="M114.697 150.607c.486 3.464-5.232 27.006.821 31.84 1.887 1.505 9.27-1.673 11.412-1.673 12.623-.024 9.429 3.568 7.534 3.807-1.895.239-15.02 2.405-17.449 2.182-2.429-.223-8.593-2.174-7.892-6.371 1.138-6.817.86-38.92 1.568-42.488.16-.796 2.151-.509 4.006 12.711v-.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <G id="Group" fill="#000">
          <Path
            id="Vector_4"
            d="M167.554 144.084c-3.432-3.623-15.657-8.298-30.295 2.7-.581.438-.414 1.569 0 2.166.414.598.908.415 1.513 0 2.246-1.553 4.842-2.652 7.542-3.384v.048c0 3.695 3.186 6.689 7.112 6.689s7.112-2.994 7.112-6.689c0-.287-.024-.566-.056-.837 2.397.367 4.428.988 5.822 1.768.239.136.414.295.629.295.327 0 .653-.215.86-.621.351-.685.247-1.641-.231-2.142l-.008.007Z"
          />
          <Path
            id="Vector_5"
            d="M84.952 149.285c-.359.485-.383 1.369-.056 1.975.199.358.478.541.748.525.184-.016.359-.111.502-.31.964-1.29 3.839-3.481 7.375-4.89a6.261 6.261 0 0 0-.088 1.035c0 3.48 3.003 6.308 6.706 6.308 3.703 0 6.602-2.74 6.698-6.141.661.574 1.29 1.243 1.871 2.047.382.526.932.486 1.243-.08.302-.573.246-1.457-.136-1.983-7.94-10.966-22.251-1.975-24.847 1.522l-.016-.008Z"
          />
        </G>
        <Path
          id="Vector_6"
          d="M112.714 136.487c.136 1.234-1.322 3.082-2.477 3.082-5.375 0-3.814-.398-16.716.733-5.83.509-12.902 4.308-12.902 4.308s-.907-7.183 1.808-10.297c1.673-1.92 7.016-3.688 12.488-4.357 4.579-.565 9.604-.868 12.567.502 4.627 2.134 4.914 3.098 5.232 6.037v-.008Z"
          fill="#000"
        />
        <Path
          id="Vector_7"
          d="M113.025 212.909s5.36 1.187 9.644 1.028c4.285-.16 10.25-2.198 10.25-2.198 1.354-.08 2.254.422 1.593 1.489-1.139 1.84-3.919 4.109-10.704 4.516-6.578.39-10.09-1.386-11.906-3.011-1.035-.924-.327-1.736 1.139-1.824h-.016Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_8"
          d="M111.066 198.215c3.886 0 6.681 1.474 6.681 1.474s3.401-1.8 7.526-1.8c4.126 0 7.893 1.632 11.779 2.046 2.079.215 7.59-.294 9.31-.374.486-.024.629.55.175.701-4.117 1.362-16.055 5.431-27.571 5.431-6.419 0-10.831-1.624-14.399-2.468-.773-.184-1.027-1.004-.478-1.506 1.505-1.361 4.325-3.504 6.985-3.504h-.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="hair"
          d="M197.244 164.417a41.52 41.52 0 0 1 1.298-3.911c5.033-13.037 10.258-23.222 23.064-19.01 1.003-3.352 1.943-6.641 2.612-9.301 2.373-9.374 12.113-18.572 8.617-39.032-3.496-20.46-18.038-22.61-18.038-22.61s4.842-2.962-9.151-16.421c-13.993-13.46-22.347-3.767-31.227-7.272-8.888-3.496-6.459-8.617-12.384-9.692-5.925-1.075-12.384 0-24.226 1.346-11.843 1.346-17.768-2.962-32.302 1.346-14.534 4.309-17.226 25.843-17.226 25.843s-9.422 3.234-18.039 15.347 1.346 35.535 10.497 42.806c-2.421-18.572 8.617-38.227 15.617-40.919 7.001-2.691 12.926 5.925 22.61 3.496s11.309-12.113 17.497-12.113c6.188 0 3.496-.541 13.73 9.963 10.234 10.497 21.264 14.272 26.114 12.655 4.842-1.617-2.151-7.805-2.151-7.805l19.918 13.73s-6.188-2.15-11.308-2.15c-5.121 0-3.497 7-3.497 9.421 0 2.421 11.309 10.234 13.189 14.001 1.887 3.767-1.888 40.115-1.888 40.115l6.674.183v-.016Z"
          fill={c.hair}
        />
        <Path
          id="Vector_9"
          d="M226.536 260.565c-4.89-10.393-6.109-33.616-6.109-33.616s-4.977-2.676-13.403-4.627l1.784 16.764-77.57 48.796-7.788-36.236c-12.552 13.833-21.83 29.888-27.572 41.357 17.314 6.865 36.189 10.647 55.947 10.647 35.44 0 68.045-12.145 93.88-32.493-8.076-2.062-16.732-5.423-19.169-10.6v.008Z"
          fill="#000"
        />
        <Path
          id="Vector_10"
          d="M201.473 186.708c-13.515 39.119-46.462 57.006-73.85 57.006-2.079 0-4.038-.151-5.91-.422 2.477 10.353 5.328 22.689 6.714 30.08 5.4-.08 10.998-.629 16.302-1.991 20.531-5.256 35.559-35.559 42.815-47.322 3.775-6.117 10.52-25.421 16.135-42.56l-.064-.167a120.613 120.613 0 0 1-2.15 5.376h.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_2286_5431">
          <Rect width={303.667} height={303.667} fill="#fff" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
